import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.378 9.456C9.378 7.547 10.948 6 12.885 6s3.507 1.547 3.507 3.456a3.41 3.41 0 0 1-.84 2.244H13.7a2 2 0 0 0-1.777 1.08c-1.47-.411-2.545-1.744-2.545-3.324Zm2.322 4.85c-1.12.022-2.18.075-3.175.16a2.441 2.441 0 0 0-2.21 2.014l-.296 1.753c-.115.68.297 1.34.966 1.546 1.32.407 2.891.644 4.715.714v-6.187Zm14.412-1.576H13.708a.818.818 0 0 0-.823.812V21.6c0 .447.37.811.823.811h12.404a.818.818 0 0 0 .823-.811v-8.058a.818.818 0 0 0-.823-.812ZM24.3 24.413h-2.222v-1.19h-4.336v1.19H15.52a.409.409 0 0 0-.411.406c0 .224.184.406.411.406h8.782a.409.409 0 0 0 .411-.406.409.409 0 0 0-.411-.406Z",
    fill: "currentColor"
  }));
};

var SvgOnboarding = styled(SvgComponent).withConfig({
  displayName: "Onboarding__SvgOnboarding",
  componentId: "sc-19j74wh-0"
})(["", " ", ""], size, color);
export default SvgOnboarding;